import axios from 'axios';

export const getInstagramPosts = () => {
    return axios.get(process.env.VUE_APP_BACKEND_URL + '/v1/instagram/posts')
        .then(response => response.data)
        .catch(error => Promise.reject(error));
};